import { Component, OnInit, ViewChild, ElementRef, TemplateRef, ChangeDetectorRef, OnDestroy, HostListener, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { CommonFunctionService } from '../../services/common-function.service';
import { LayerService, AppLayer } from '../../services/layer.service';
import { CommonModalService } from '../../services/common-modal.service';
import { LayerQcService } from '../../services/layer-qc.service';
import { UserService, CustomerType } from '../../services/user.service';

import { ConfirmModalComponent, ConfirmModalData } from '../modal/confirm-modal/confirm-modal.component';
import { CommonTableService, TableColumn } from 'app/services/common-table.service';

import { LB } from '../../../assets/TS/LBCore';
import { AppinfoService } from 'app/services/appinfo.service';
import { DownloadService } from 'app/services/download.service';
import { IntegratorService } from 'app/services/integrator.service';
import { Subscription } from 'rxjs';
import { MiscService } from 'app/services/misc.service';
import { PaneControlService } from 'app/services/pane-control.service';
import { ElasticsearchService } from 'app/services/elasticsearch.service';
import { TransactionInfo, TransactionsService, Transaction } from 'app/services/transactions.service';
import { CommonTablePagingComponent } from 'app/components/common-datagrid/common-table-paging/common-table-paging.component';
import { PagingParam } from 'app/services/common-request.service';
import { ContentJobsService } from 'app/components/content-jobs/content-jobs.service';
import { GfoService, ColumnFilter, Gfo } from 'app/services/gfo.service';
import { FeatureTab } from 'app/components/feature-vertical-tabs/feature-vertical-tabs.component';
import { MainDataService } from 'app/services/main-data.service';

interface Column {
	name: string;
	value: string;
	type?: 'date' | 'string' | 'number' | 'json';
	sortOrder?: 1 | -1; // 1: ascending, 0: descending
}
interface DownloadableLayer {
	isDownload?: boolean;
	isDownloadQc?: boolean;
	name: string;
	layerId;
}

type TabKey = 'maintain' | 'snap';

@Component({
	selector: 'app-dashboard-main',
	templateUrl: './dashboard-main.component.html',
	styleUrls: ['./dashboard-main.component.css']
})
export class DashboardMainComponent implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('summaryTableContainer', { static: false }) tableContainer: ElementRef;
	@ViewChild('layerStateHeaderTempl', { static: false }) layerStateHeaderTempl: TemplateRef<any>;
	@ViewChild('layerStateTempl', { static: false }) layerStateTempl: TemplateRef<any>;
	@ViewChild('layerOwnerTempl', { static: false }) layerOwnerTempl: TemplateRef<any>;
	@ViewChild('operationsTempl', { static: false }) operationsTempl: TemplateRef<any>;
	@ViewChild('tooltipTempl', { static: false }) tooltipTempl: TemplateRef<any>;
	// Tabs
	@ViewChild('tabMaintain', { static: false }) tabMaintainTempl;
	@ViewChild('tabSnap', { static: false }) tabSnapTempl;

	// Snap table
	public rows: any[] = [];
	public columns: TableColumn[] = [];
	public selectedRows = [];
	// Maintain table
	rows_maintain: any[] = [];
	columns_maintain: TableColumn[] = [];
	selectedRows_maintain = [];

	// Layer list
	private liveLayers: AppLayer[];
	private publishLayers: AppLayer[];
	// Selected layers
	public selectedLayer: AppLayer;
	// Regular columns (not including remove col or state col)
	public regularCols: Column[] = [{
		name: 'Layer Category',
		value: 'category.name',
		sortOrder: 1
	}, {
		name: 'Requirement Status',
		value: 'category.status',
		sortOrder: 1
	}, {
		name: 'Standard Agency',
		value: 'category.definedBy',
		sortOrder: 1
	}, {
		name: 'Source Layer Name',
		value: 'name',
		sortOrder: 1
	}, {
		name: 'Record count',
		value: 'recordCount',
		sortOrder: 1
	}];
	//
	tabList: FeatureTab<TabKey>[];
	selectedTab: FeatureTab<TabKey>;
	//
	// public downloadableLayers: DownloadableLayer[] = [];
	// public showDownloadPopup: boolean;
	// public isPopupDownloadAll = true;
	showDownloadBtn: boolean;

	public isDownloading = false;
	public isDownloadingQC = false;
	public isSending = false;

	// Is user a administrator
	public isAdmin: boolean;
	public customerId: number;
	public customerType: CustomerType;
	// Selected customer (can be same as customerId, or one of its children agency id)
	public selectedCustomerId: number;
	// Parent customerId // Only allow submit if user has parent agency
	public parentCusId: number;
	public parentCusId_integratorClient: number; // Integrator client (currently selected)'s parent customer id
	public customerLevel: number;

	layerStatesHeader = [{
		name: 'created',
		display: 'Created'
	}, {
		name: 'qc',
		display: 'QA/QC'
	}, {
		name: 'submitted',
		display: 'SUBMITTED'
	}, {
		name: 'disapproved',
		display: 'DISAPPROVED'
	}, {
		name: 'approved',
		display: 'APPROVED'
	}]; // States to display in slider
	layerCateCodeCol = {
		prop: 'layerCateCode',
		name: 'LAYER CATEGORY'
	};
	layerStateCol = {
		prop: 'layerStatus'
	};
	private layerOwnerCol = {
		prop: 'layerOwner',
		name: 'Owner'
	};
	private layerCateCol = {
		prop: 'layerCate',
		name: 'LAYER CATEGORY'
	};
	layerMaintainTypeCol = {
		prop: 'layerType',
		name: 'Type'
	}; // Live, replica, etc
	private layerNameCol = {
		prop: 'name',
		name: 'LAYER NAME'
	};
	private recordCountCol = {
		prop: 'recordCount',
		name: 'RECORD #'
	};
	private requirementCol = {
		prop: 'requirement',
		name: 'Requirement'
	};
	private operationsCol = {
		prop: 'operations',
		name: 'Layer Operations'
	};
	layerCusIdColName = 'layerCusId';
	private tooltipCol = 'tooltip';
	public isBuiltTopoCol = 'isBuiltTopo';
	
	isPublishingCol = 'isPublishing';


	// Job List

	public transactionInfo: TransactionInfo;
	public transcSearchStr: string;
	// @Input() transactionInfo: TransactionInfo;
	@ViewChild('tablePaging', { static: false }) tablePaging: CommonTablePagingComponent;
	// Table columns. name: the name to display in table, value: matching column name in transactions
	// This is hard coded. Order matters.
	public jobsColumns: Column[] = [{
		name: 'Time',
		value: 'startTime',
		type: 'date',
		sortOrder: 1
	}, {
		name: 'Data File',
		value: 'details',
		type: 'json'
	}, {
		name: 'Transaction Type',
		value: 'type',
		type: 'string',
		sortOrder: 1
	}, {
		name: 'User',
		value: 'userName',
		type: 'string',
		sortOrder: 1
	}];
	public sortedCol: Column;
	// Paging info
	public paging: {
		pageSize: number;
		footerHeight: number;
	};
	// Total number (not current page's number of records)
	public total: number;
	//
	public transcLogs;
	public showLogsPopup = false;
	// Subscribe on uploading finish
	private uploadingFinishSub: Subscription;

	private selectedCustomerSub: Subscription;
	private layerListSub: Subscription;

	constructor(
		private ref: ChangeDetectorRef,
		private router: Router,
		private route: ActivatedRoute,
		private toastr: ToastrService,
		private appinfoService: AppinfoService,
		private commonService: CommonFunctionService,
		private tableService: CommonTableService,
		private downloadService: DownloadService,
		private integratorService: IntegratorService,
		private gfoService: GfoService,
		private layerService: LayerService,
		private qcService: LayerQcService,
		private mainDataService: MainDataService,
		private miscService: MiscService,
		private paneService: PaneControlService,
		private modalService: CommonModalService,
		private jobsService: ContentJobsService,
		private transactionService: TransactionsService,
		private userService: UserService,
		// private esService: ElasticsearchService
	) { }

	@HostListener('document:click', ['$event'])
	onDocumentClick(e) {
		// if (e.target) {
		// 	if (this.showDownloadPopup) {
		// 		this.toggleLoadingLogs
		// 	}
		// 	if (this.showLogsPopup) {}
		// }
	}

	onChangeTab(e: FeatureTab<TabKey>) {
		this.selectedTab = e;
	}

	async clickLayer(e) {
		this.selectedLayer = this.liveLayers.find(l => l.category.code === e.selected[0][this.layerCateCodeCol.prop]);
		// Check loaded layer for its submitStatus
		if (this.selectedLayer.id) {
			this.commonService.setLoadingSpinner(true);
			try {
				if (!this.selectedLayer.submitStatus) {
					this.selectedLayer.submitStatus = await this.qcService.getSubmitStatus(this.selectedLayer.id);

					// TODO!!!!!!!!!!!!! REMOVE after test
					this.selectedLayer.submitStatus.hasError = false;
					// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!


				}
			} catch (err) {
				console.log(err);
			}
			this.commonService.setLoadingSpinner(false);
		}
	}
	clickLayer_maintain() {
		// TODO
	}
	newJob() {
		// this.stateService.go('jobsfilesadd');
		this.router.navigate(['azgiv/jobs/add-files']);
	}
	viewData() {
		// this.stateService.go('jobsfilesreview', {
		// 	layerId: this.selectedLayer ? this.selectedLayer.id : null
		// });
		const layerId = this.selectedLayer ? this.selectedLayer.id : '';
		this.router.navigate(['azgiv/review/data-view', layerId]);
	}

	buildTopo() {
		const customerId = this.userService.selectedCustomer.getValue().id; // this.userService.getUserInfo().customerId;
		const userId = this.userService.getUserInfo().userId;
		const userSubId = this.userService.getUserInfo().userSubId;
		this.qcService.buildTopology(customerId, userId, userSubId);
	}
	downloadLayers() {
		// setTimeout is for selectedLayer to be populated
		setTimeout(() => {
			if (!this.selectedLayer) { return; }
			if (this.isDownloading) { return; }
			this.isDownloading = true;
			const cusName = this.getSelectedCusNameByType();

			this.downloadService.fileGet([{
				layerId: this.selectedLayer.id,
				schema: 'state'
			}], cusName).then((data) => {
				const url = data.path;
				// to download the file with a meaningful name
				const anchor = document.createElement('a');
				// The rename doesn't work anymore. see: https://stackoverflow.com/questions/23872902/chrome-download-attribute-not-working/35290284
				// anchor.download = this.selectedLayer.name + '.zip';
				anchor.href = url;
				anchor.target = '_blank';
				document.body.appendChild(anchor);
				anchor.click();
				document.body.removeChild(anchor);
				this.isDownloading = false;
			}, (err) => {
				console.log(err);
				this.isDownloading = false;
			});
		});
	}
	async downloadQC() {
		// setTimeout is for selectedLayer to be populated
		setTimeout(async () => {
			this.isDownloadingQC = true;
			const query = await this.qcService.getQcFeatureReportQuery(this.selectedLayer.id);
			this.downloadService.download(query.sql).then((data: any) => {
				const url = data.content;
				// to download the file with a meaningful name
				const anchor = document.createElement('a');
				anchor.download = this.selectedLayer.name + '.txt';
				anchor.href = url;
				anchor.target = '_blank';
				document.body.appendChild(anchor);
				anchor.click();
				document.body.removeChild(anchor);
				this.isDownloadingQC = false;
			});
		});
	}
	// private getDownloadableLayers() {
	// 	this.downloadableLayers = this.liveLayers.filter(l => l.state >= 1).map(l => {
	// 		return {
	// 			layerId: l.id,
	// 			name: l.name,
	// 			isDownload: true
	// 		}
	// 	});
	// 	// if (this.selectedCustomerId === this.customerId || this.customerType === 'integrator') {
	// 	// 	this.downloadableLayers = this.layers.filter(l => l.state >= 1).map(l => {
	// 	// 		return {
	// 	// 			layerId: l.id,
	// 	// 			name: l.name,
	// 	// 			isDownload: true,
	// 	// 			isDownloadQc: l.state >= 2
	// 	// 		}
	// 	// 	});
	// 	// } else if (this.selectedCustomerId !== this.customerId) {
	// 	// }
	// }
	// public disableDownloadBtn() {
	// 	if (this.downloadableLayers.length === 0) {
	// 		return true;
	// 	}
	// 	return false;
	// }
	// public clickDownload() {
	// 	this.toggleDownloadPopup(true);
	// }
	// public clickPopupDownload() {
	// 	this.toggleDownloadPopup(false);
	// 	// TODO


	// 	// download selected files



		
	// }
	// private toggleDownloadPopup(isOpen: boolean) {
	// 	this.showDownloadPopup = isOpen;
	// }
	// public togglePopupDownloadAll() {
	// 	this.downloadableLayers.forEach(l => l.isDownload = this.isPopupDownloadAll);
	// }

	async sendToDataSupplyChain() {
		// setTimeout is for selectedLayer to be populated
		setTimeout(async () => {
			if (!this.selectedLayer) { return; }
			if (this.isSending) { return; }
			this.commonService.setLoadingSpinner(true);
			this.isSending = true;
			try {
				let email, cusName;
				if (this.userService.customerInfo.type === 'integrator') {
					// Get client customer's parent info
					const info = await this.userService.getCustomerInfo(this.selectedCustomerId, false, true);
					email = info.parentEmails ? info.parentEmails.join() : null;
				} else {
					email = this.userService.customerInfo.parentEmails ? this.userService.customerInfo.parentEmails.join() : null; // 'shujing.li@gisticinc.com';
				}
				cusName = this.getSelectedCusNameByType();
				await this.downloadService.fileGet([{
					layerId: this.selectedLayer.id,
					schema: 'state'
				}], cusName, email, this.userService.getUserInfo().customerName);
				this.toastr.success('The data has been successfully sent.');
			} catch (err) {
				this.toastr.error('Failed to send data.')
			}
			this.isSending = false;
			this.commonService.setLoadingSpinner(false);
		});
	}

	private async updateLayerList() {
		await this.layerService.getLayers(this.selectedCustomerId);
	}
	async submitLayer() {
		if (this.selectedLayer && this.selectedLayer.submitStatus && !this.selectedLayer.submitStatus.hasError) {
			const options = this.modalService.confirmModalOptions;
			const data: ConfirmModalData = {
				message: 'You are about to submit ' + this.selectedLayer.name + ' layer, click OK to continue.',
				yesBtnText: 'OK'
			};
			options.data = data;
			const rsp = await this.modalService.openModalWindow(ConfirmModalComponent, options);
			if (rsp) {
				this.commonService.setLoadingSpinner(true);
				try {
					let parentEmails;
					if (this.userService.customerInfo.type === 'integrator') {
						const customer = this.userService.clients.find((c) => c.cusId === this.userService.selectedCustomer.getValue().id);
						const parentInfo = await this.userService.getCustomerInfo(customer.parentId, false);
						parentEmails = parentInfo.adminEmails ? parentInfo.adminEmails.join() : '';
					} else {
						parentEmails = this.userService.customerInfo.parentEmails.join();
					}
					if (!parentEmails) {
						this.toastr.warning('Parent agency does not exist to submit layers.');
						this.commonService.setLoadingSpinner(false);
						return;
					}
					await this.qcService.submitLayer(this.selectedLayer, parentEmails);
					this.toastr.success('Successfully submitted.');
					// Update layerList
					await this.updateLayerList();
				} catch (err) {
					this.toastr.warning('Failed.');
					console.log(err);
				}
				this.commonService.setLoadingSpinner(false);
			}
		}
	}
	async onChangeCustomer(e) {
		this.commonService.setLoadingSpinner(true);
		this.selectedCustomerId = e.id;
		if (this.userService.customerInfo.type === 'integrator') {
			const cus = this.userService.clients.find((c) => c.cusId === e.id);
			if (cus) {
				this.parentCusId_integratorClient = cus.parentId;
			}
		}
		try {
			await this.updateLayerList();
			// this.onLayersUpdate();
			// this.selectedLayer = this.selectedLayer ? this.liveLayers.find((l) => !!l.state && l.category.code === this.selectedLayer.category.code) : null;
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false);
	}
	async revokeSubmittedLayer() {
		if (!this.selectedLayer) { return; }
		const options = this.modalService.confirmModalOptions;
		const data: ConfirmModalData = {
			message: 'Are you sure you want to revoke the submission of ' + this.selectedLayer.name
		};
		options.data = data;
		const rsp = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		if (rsp) {
			this.updateSelectedLayerStatus(this.appinfoService.layerStateMap.qc, 'The submission is revoked.');
		}
	}
	async approveSubmit() {
		if (!this.selectedLayer) { return; }
		const options = this.modalService.confirmModalOptions;
		const data: ConfirmModalData = {
			message: 'Continue to approve the submission of ' + this.selectedLayer.name
		};
		options.data = data;
		const rsp = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		if (rsp) {
			try {
				this.updateSelectedLayerStatus(this.appinfoService.layerStateMap.approve, 'The submission is approved.');
				// Send email to subagency
				const content = `The ${this.selectedLayer.name} dataset was accepted by ${this.userService.customerInfo.nameShort}`;
				try {
					const emails = this.userService.selectedCustomer.getValue().adminEmails;
					this.miscService.sendEmail(emails.join(), content);
				} catch (err) {
					this.toastr.error('Failed to notify ' + this.userService.selectedCustomer.getValue().nameShort);
					console.log(err);
				}
			} catch (err) {
				console.log(err);
			}

		}
	}
	async rejectSubmit() {
		if (!this.selectedLayer) { return; }
		const options = this.modalService.confirmModalOptions;
		const data: ConfirmModalData = {
			message: 'Continue to reject the submission of ' + this.selectedLayer.name
		};
		options.data = data;
		const rsp = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		if (rsp) {
			this.updateSelectedLayerStatus(this.appinfoService.layerStateMap.disapprove, 'The submission is rejected.');
			// Send email to subagency
			const content = `The ${this.selectedLayer.name} dataset was rejected by ${this.userService.customerInfo.nameShort}`;
			try {
				const emails = this.userService.selectedCustomer.getValue().adminEmails;
				this.miscService.sendEmail(emails.join(), content);
			} catch (err) {
				this.toastr.error('Failed to notify ' + this.userService.selectedCustomer.getValue().nameShort);
				console.log(err);
			}
		}
	}
	async revokeApproveOrReject() {
		if (!this.selectedLayer) { return; }
		let text;
		switch (this.selectedLayer.state.num) {
			case 4: text = 'disapproval'; break;
			case 5: text = 'approval'; break;
			default: return;
		}
		const data: ConfirmModalData = {
			message: 'Are you sure you want to revoke the ' + text + ' of ' + this.selectedLayer.name
		};
		const options = this.modalService.confirmModalOptions;
		options.data = data;
		const rsp = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		if (rsp) {
			this.updateSelectedLayerStatus(this.appinfoService.layerStateMap.submit, 'Revoked successfully.');
		}
	}
	// Update layer status
	private async updateSelectedLayerStatus(status, successMsg) {
		if (!this.selectedLayer) { return; }
		this.commonService.setLoadingSpinner(true);
		try {
			await this.layerService.updateLayerStatus(this.selectedLayer.id, status);
			this.toastr.success(successMsg);
			await this.updateLayerList();
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false);
	}

	//
	async publish(row) {
		const layer = this.liveLayers.find(l => l.category.code === row[this.layerCateCodeCol.prop]);
		if (layer && (layer.id || layer.id === 0)) {
			row.disablePublishButton = true;
			row[this.isPublishingCol] = true;
			try {
				await this.layerService.publishLayers([layer.id]);
				this.toastr.success('Layer is published successfully')
			} catch (err) {
				console.log(err);
				this.toastr.error('Failed to publish the layer');
			}
			row.disablePublishButton = false;
			row[this.isPublishingCol] = false;
		}
	}

	getDisableStatus(row) {
		return row.disablePublishButton;
	}

	private getSelectedCusNameByType() {
		let cusName;
		switch (this.userService.customerInfo.type) {
			case 'integrator':
				const cus = this.userService.clients.find((c) => c.cusId === this.selectedCustomerId);
				if (cus) {
					cusName = cus.cusNameShort;
				}
				break;
			default:
				cusName = this.userService.customerInfo.nameShort;
				if (this.selectedCustomerId !== this.customerId) {
					cusName = this.userService.customerInfo.children.find((c) => c.id === this.selectedCustomerId).name;
				}
		}
		return cusName;
	}
	private onLayersUpdate() {
		this.setMaintainTable();
		this.setSnapTable();
		// this.getDownloadableLayers();
		// check download accessibility
		this.showDownloadBtn = !!this.layerService.layerListBS.getValue().layers.filter(l => l.state.num >= 1).length;
	}
	private setSnapTable() {
		const rows = [];
		this.publishLayers.forEach((l) => {
			// if (!l.maintainType || l.maintainType.toUpperCase() !== 'SNAP') {
			// 	return;
			// }
			// Build row object
			const row: any = {};
			// Add layerName col & recordCount col
				// row[this.layerNameCol] = l.name;
			row[this.recordCountCol.prop] = l.recordCount;
			row[this.isBuiltTopoCol] = l.isBuiltTopo;
			//
			if (l.category) {
				// Build tooltip
				let tooltip = 'Standard Agency: ' + l.category.definedBy + ' \n'
				if (l.category.status === 'MD') {
					tooltip += 'Requirement Status: Mandatory \n';
				} else if (l.category.status === 'SR') {
					tooltip += 'Requirement Status: Strongly Recommended \n';
				}
				row.tooltip = tooltip;
				// Add layerCate col & status col
				row[this.layerCateCol.prop] = l.category.name;
				row[this.requirementCol.prop] = l.category.status;
				row[this.layerStateCol.prop] = l.state;
				row[this.layerCateCodeCol.prop] = l.category.code;
				row[this.layerOwnerCol.prop] = l.category.isStateMaintained;
			}
			row.disablePublishButton = false;
			rows.push(row);
		});
		// Add columns from rows so that they could have smart display
		const cols: TableColumn[] = this.tableService.setColumnsFromRows(rows);
		// Remove layer cate code col
		cols.splice(cols.findIndex(c => c.prop === this.layerCateCodeCol.prop), 1);
		cols.forEach((c) => {
			// Hard code col names & other properties as need
			if (c.prop === this.layerNameCol.prop) {
				c.name = this.layerNameCol.name;
				c.seq = 3;
			} else if (c.prop === this.layerCateCol.prop) {
				c.name = this.layerCateCol.name;
				c.seq = 2;
				c.cellTemplate = this.tooltipTempl;
			} else if (c.prop === this.recordCountCol.prop) {
				c.name = this.recordCountCol.name;
				c.seq = 4;
			} else if (c.prop === this.layerStateCol.prop) {
				c.headerTemplate = this.layerStateHeaderTempl;
				c.cellTemplate = this.layerStateTempl;
				c.width = 440;
				c.seq = 5;
			} else if (c.prop === this.layerOwnerCol.prop) {
				c.name = this.layerOwnerCol.name;
				c.width = 50;
				c.seq = 1
				c.cellTemplate = this.layerOwnerTempl;
			} else if (c.prop === this.tooltipCol || c.prop === this.isBuiltTopoCol || c.prop === this.requirementCol.prop) {
				this.tableService.hideColumn(c);
			}
			c.sortable = true;
		});
		// Add the operation col
		cols.push(this.tableService.setNewColumn(this.operationsCol.prop, this.operationsCol.name, {
			cellTemplate: this.operationsTempl,
			width: 400
		}));
		cols.sort(this.sortColBySeq);
		this.columns = cols;
		this.rows = rows;
	}
	private setMaintainTable() {
		const rows = [];
		this.liveLayers.forEach((l) => {
			// Build row object
			const row: any = {};
			row[this.recordCountCol.prop] = l.recordCount;
			row[this.layerMaintainTypeCol.prop] = l.maintainType;
			//
			if (l.category) {
				row[this.layerCateCodeCol.prop] = l.category.code;
				row[this.layerOwnerCol.prop] = l.category.isStateMaintained;
			}
			row[this.layerStateCol.prop] = l.state;
			rows.push(row);
			row[this.layerCusIdColName] = l.cusId;
		});
		// Add columns from rows so that they could have smart display
		const cols: TableColumn[] = [];
		const allCols = this.tableService.setColumnsFromRows(rows);
		// const displayedColProps = [this.layerOwnerCol.prop, this.layerCateCol.prop, this.layerMaintainTypeCol.prop, this.layerNameCol.prop, this.recordCountCol.prop, this.requirementCol.prop, this.operationsCol.prop, this.tooltipCol];
		const hiddenCols = [this.layerStateCol.prop, this.isPublishingCol];
		allCols.forEach((c) => {
			// if (displayedColProps.indexOf(c.prop) === -1) {
			// 	return;
			// }
			// Hard code col names & other properties as need
			if (c.prop === this.layerOwnerCol.prop) {
				c.name = this.layerOwnerCol.name;
				c.maxWidth = 50;
				c.seq = 1
				c.cellTemplate = this.layerOwnerTempl;
			} else if (c.prop === this.layerCateCodeCol.prop) {
				c.name = this.layerCateCodeCol.name;
				c.seq = 2;
				c.cellTemplate = this.tooltipTempl;
			} else if (c.prop === this.layerMaintainTypeCol.prop) {
				c.name = this.layerMaintainTypeCol.name;
				c.minWidth = 100;
				c.seq = 3;
			} else if (c.prop === this.recordCountCol.prop) {
				c.name = this.recordCountCol.name;
				c.seq = 4;
			} else if (hiddenCols.indexOf(c.prop) > -1) {
				return;
			}
			c.sortable = true;
			cols.push(c);
		});
		// Add the operation col
		cols.push(this.tableService.setNewColumn(this.operationsCol.prop, this.operationsCol.name, {
			cellTemplate: this.operationsTempl,
			minWidth: 150
		}));
		//
		cols.sort(this.sortColBySeq);
		this.columns_maintain = cols;
		this.rows_maintain = rows;
	}
	setRowClass = (row) => {
		if (this.selectedRows.indexOf(row) > -1) {
			return 'selected-layer';
		}
	}
	private sortColBySeq = (a, b) => {
		if (!b.seq) {
			return -1;
		} else if (!a.seq) {
			return 1;
		} else if (a.seq > b.seq) {
			return 1;
		} else {
			return -1;
		}
	};


	// Job List
	clickHeader(idx) {
		const col = this.jobsColumns[idx];
		if (this.transactionInfo.transactions && col.hasOwnProperty('sortOrder')) {
			this.sortedCol = col;
			col.sortOrder = col.sortOrder === 1 ? -1 : 1;
			switch (col.type) {
				case 'date':
					this.transactionInfo.transactions.sort((a, b) => {
						return col.sortOrder * ((new Date(a[col.value])).valueOf() - (new Date(b[col.value])).valueOf());
					});
					break;
				case 'string':
				default:
					this.transactionInfo.transactions.sort((a, b) => {
						if (a[col.value] > b[col.value]) {
							return col.sortOrder * -1;
						} else {
							return col.sortOrder * 1;
						}
					});
			}
		}
	}
	async updateTransactions(paging: PagingParam) {
		let gfo: Gfo;
		let searchFilter: ColumnFilter, timeFilter: ColumnFilter;
		const filters: ColumnFilter[] = [];
		if (this.transcSearchStr) { // TODO
			// searchFilter = this.gfoService.getFilter('', this.gfoService.filterOperators.contain, this.transcSearchStr);
			// filters.push(searchFilter)
		}
		if (filters.length) {
			gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, filters);
		}
		try {
			this.transactionInfo = await this.transactionService.getTransactions(gfo, paging);
		} catch (err) {
			this.transactionInfo = {
				transactions: [],
				total: 0
			};
		}
		// this.clickHeader(0); // sort by time by defaul
	}
	setPage(pageNum: number) {
		const paging: PagingParam = {
			pageSize: this.paging.pageSize,
			pageNumber: pageNum,
			rowCount: 0
		};
		this.updateTransactions(paging);
	}
	clickTransc() { }
	searchTransc() {
		const paging = { rowCount: 1, pageSize: 10 };
		this.updateTransactions(paging);
	}
	async toggleLoadingLogs(isOpen: boolean, transc?: Transaction) {
		if (transc) {
			if (!transc.logs) {
				this.commonService.setLoadingSpinner(true);
				try {
					transc.logs = await this.transactionService.getTransactionLog([transc.sessionId]);
					this.transcLogs = transc.logs;
				} catch (err) {
					console.log(err);
				}
				this.commonService.setLoadingSpinner(false);
			}
			this.transcLogs = transc.logs;
		}
		this.showLogsPopup = isOpen;
	}


	async ngOnInit() {
		// Tell paneControl current pane is switched to dashboard, so that the highlighted menu item can change to dashboard
		this.paneService.currPane.next({
			paneType: 'dashboard'
		});
		this.isAdmin = this.userService.getUserInfo().isAdmin;
		this.customerId = this.userService.getUserInfo().customerId;
		this.customerType = this.userService.customerInfo.type;
		// this.selectedCustomerId = this.userService.selectedCustomerId || this.customerId;
		//
		this.selectedCustomerSub = this.userService.selectedCustomer.subscribe((data) => {
			if (data) {
				let selectedCustomerId = data.id;
				this.onChangeCustomer({
					id: selectedCustomerId
				});
			}
		});
		this.layerListSub = this.layerService.layerListBS.subscribe(data => {
			this.liveLayers = this.layerService.getLiveLayerFromLayerList();
			this.publishLayers = data.publishedLayers;
			this.onLayersUpdate();
		});
		this.parentCusId = this.userService.customerInfo.parentId;
		this.customerLevel = this.userService.customerInfo.level;

		this.route.data.subscribe((data) => {
			// this.liveLayers = data.layers || [];
			// this.publishLayers = this.layerService.publishedLayerList || [];
			// this.onLayersUpdate();
			//
			this.transactionInfo = data.transactionInfo || {
				transactions: [],
				total: 0
			};
			this.clickHeader(0); // sort by time by defaul
		});

		this.mainDataService.contentMenuItemKeyBS.next('home');

		// Job list
		this.paging = {
			pageSize: 10,
			footerHeight: 50,
		};
		this.total = (!this.transactionInfo.total || this.transactionInfo.total < 0) ? 0 : this.transactionInfo.total;
		this.uploadingFinishSub = this.jobsService.onUploadingFinish.subscribe((data) => {
			if (!data.isError) {
				this.updateTransactions({ rowCount: 1 });
			}
		});


		// this.esService.getAllDocuments('index', 'login').then(response => {
		// 	console.log(response);
		// }, error => {
		// 	console.error(error);
		// })
		// this.esService.test();

	}
	ngAfterViewInit(): void {
		// Tabs
		this.tabList = [{
			key: 'maintain',
			label: 'Maintain',
			template: this.tabMaintainTempl,
		}, {
			key: 'snap',
			label: 'Snap',
			template: this.tabSnapTempl,
		}];
			
	}
	ngOnDestroy() {
		this.selectedCustomerSub.unsubscribe();
		this.uploadingFinishSub.unsubscribe();
		this.layerListSub.unsubscribe();
	}
}
